import Taxes from './Taxes';

export { StsTaxes } from './partnersTaxes/StsTaxes';

export default new Taxes();
